<div class="confirm-code">
  <div class="confirm-code__title">
    <h3>{{ 'forgotPassword.title' | translate }}</h3>
    @if (message$ | async; as message) {
      <p>{{ message }}</p>
    }
  </div>

  <form
    autocomplete="off"
    [formGroup]="form"
    (submit)="submit()"
  >
    <div class="d-grid gap-2">
      <cx-input-code
        mode="numeric"
        formControlName="code"
        [label]="'forgotPassword.confirmCode.enterCode' | translate"
        [invalid]="!!(error$ | async)"
        [hintText]="(error$ | async) ?? ''"
      />

      <button
        type="button"
        class="btn-resend"
        (click)="resendCode()"
        [disabled]="isLoading$ | async"
      >
        <span class="icon material-symbols-outlined">redo</span>
        {{ 'forgotPassword.confirmCode.resendCode' | translate }}
      </button>
    </div>

    <div class="d-grid">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid || (isLoading$ | async)"
      >
        @if (isLoading$ | async) {
          <local-loader />
        }
        @else {
          {{ 'forgotPassword.confirmCode.submit' | translate }}
        }
      </button>
    </div>
  </form>
</div>
